// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"b5d4d7a5","71":"2c8f1d04","453":"d503363a","501":"3452e5e7"}[chunkId] + ".chunk.js";
};